export enum ActiveSessionsAction {
  REVOKE = "revokeSession",
}
